import Phaser from 'phaser';
import { appConfig } from '@config/app.config';
import { animationEase } from '@config/animation.config';
import { getBootstrap } from '@core/bootstrap/GameBootstrap';
import { ServiceTokens } from '@core/bootstrap/ServiceRegistry';
import type { LocalizationService } from '@localization/LocalizationService';
import { TextButton } from '@ui/components/TextButton';
import { sceneKeys } from '@utils/constants';

export class MainMenuScene extends Phaser.Scene {
  constructor() {
    super(sceneKeys.mainMenu);
  }

  create(): void {
    const { registry } = getBootstrap();
    const localization = registry.get<LocalizationService>(ServiceTokens.localization);

    this.cameras.main.setBackgroundColor('#0f1115');
    this.cameras.main.fadeIn(280, 0, 0, 0);

    const title = this.add
      .text(appConfig.gameWidth / 2, 320, localization.t('app.title'), {
        fontFamily: 'Arial, sans-serif',
        fontSize: '52px',
        color: '#ffffff',
        fontStyle: 'bold',
        align: 'center',
        wordWrap: { width: appConfig.gameWidth - 120 },
      })
      .setOrigin(0.5)
      .setAlpha(0);

    const playButton = TextButton.create(
      this,
      appConfig.gameWidth / 2,
      appConfig.gameHeight / 2 + 80,
      localization.t('menu.play'),
      () => {
        this.cameras.main.fadeOut(200, 0, 0, 0);
        this.time.delayedCall(200, () => {
          this.scene.start(sceneKeys.gameplay);
        });
      },
    );

    playButton.setAlpha(0);
    playButton.setScale(0.9);

    this.tweens.add({
      targets: title,
      alpha: 1,
      y: title.y + 8,
      duration: 420,
      ease: animationEase.outCubic,
    });

    this.tweens.add({
      targets: playButton,
      alpha: 1,
      scale: 1,
      duration: 420,
      delay: 120,
      ease: animationEase.outBack,
    });
  }
}
